<template>
  <div class="view">
    <div class="view__inner">
      <div class="text-center m-b-1">
        <SVGLogo class="view__logo" />
      </div>

      <!-- Login Form -->
      <FormLogin />

      <p class="text-center m-t-1">
        <router-link :to="{ path: '/reset-password' }" class="btn w-100">
          {{ $t('Forgot password?') }}
        </router-link>
      </p>

      <Separator class="m-t-2" :show-line="true" :text="$t('or')"></Separator>

      <p class="text-center m-t-2">
        <router-link :to="{ path: '/register' }" tag="el-button" class="w-100">
          {{ $t('Create new account') }}
        </router-link>
      </p>
    </div>

    <!-- Footer -->
    <p class="view__footer">
      <a href="https://gpal.epal-pallets.org/menus/menu-marginal/impressum/" target="_blank" :title="$t('Imprint')" class="color-brand">{{
        $t('Imprint')
      }}</a>
    </p>
  </div>
</template>

<script>
import FormLogin from '@/components/Form/FormLogin.vue';
import Separator from '@/components/Misc/Separator';
import SVGLogo from '@/assets/img/epal-deutschland-black.svg';

export default {
  name: 'Login',

  components: {
    FormLogin,
    Separator,
    SVGLogo
  }
};
</script>

<style lang="scss">
.view {
  &__inner {
    background-color: #ffffff;
    border-radius: $border-radius;
    box-shadow: 0 0 15px 0 transparentize($c-gray, 0.8);
    padding: 2rem;
    margin-right: auto;
    margin-left: auto;
    max-width: 30rem;
    width: 100%;
  }

  &__footer {
    font-size: 0.8rem;
    margin-bottom: 0;
    text-align: center;
  }

  &__logo {
    max-width: 11rem;
    height: auto;

    @media screen and (min-width: $screen-md) {
      max-width: 17rem;
    }
  }
}
</style>
